export function setEstados(state, estados) {
    state.estados = estados;
}

